const rateMatrix = {
  validHeader: {
    Type: 'type',
    Source: 'source',
    Destination: 'destination',
    'Vehicle Type': 'vehicle_type',
    Distance: 'distance',
    'Transporter Reference ID': 'transporter_refid',
    'Transporter Name': 'transporter_name',
    'Transit Days': 'transit_days',
    'Freight Rate': 'freight_rate',
    'Freight Unit': 'freight_unit',
    'Valid From': 'valid_from',
    'Valid To': 'valid_to',
    'Minimum Rate': 'minimum_rate',
    'Multiplying Factor': 'multiplying_factor',
    'Detention Group': 'detention_group',
  },
  TYPES: ['city', 'state', 'region', 'point'],
  TYPE_VALUES: {
    CITY: 1,
    STATE: 2,
    REGION: 3,
    POINT: 4,
  },
};
module.exports = { rateMatrix };
